import {NgModule} from '@angular/core';
import {ReportTemplateConverter} from './api/entity/converter/reportTemplate.converter';

@NgModule({
    providers: [
        ReportTemplateConverter
    ]
})
export class ReportTemplateModule {
}
